export const buildDashboardStatistikRange = (date = new Date()) => {
  const year = date.getFullYear();
  return {
    von_datum: `${year}-01-01`,
    bis_datum: `${year}-12-31`,
  };
};

const formatPercent = (value) => `${Number(value || 0).toFixed(1)}%`;

export const getPersonalStatItems = (statistik) => {
  if (!statistik) return [];

  const count = statistik.anzahl_gesamt || 0;
  return [
    {
      key: 'rd',
      label: 'RD',
      value: formatPercent(statistik.prozent_rd),
      count,
    },
    {
      key: 'lhf',
      label: 'L\u00f6schfahrzeug',
      value: formatPercent(statistik.prozent_lhf),
      count,
    },
    {
      key: 'sonstige',
      label: 'Sonstige',
      value: formatPercent(statistik.prozent_sonstige),
      count,
    },
  ];
};
